/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'http-status-match';
const prefix = `${moduleName}.${componentName}`;

export const statusCodesPlaceholder = `${prefix}.statusCodesPlaceholder`;
export const statusMatchHelperText = `${prefix}.statusMatchHelperText`;

export const ENGLISH = {
    [statusCodesPlaceholder]: 'Enter Status Codes',
    [statusMatchHelperText]: 'Accepts single value, comma separate, and ranges',
};
